var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,64C14.4,64,0,49.6,0,32S14.4,0,32,0s32,14.4,32,32S49.6,64,32,64z M32,4.9C17,4.9,4.9,17,4.9,32 S17,59.1,32,59.1S59.1,47,59.1,32S47,4.9,32,4.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,25.4c3.9,0,7.1-3.2,7.1-7.1s-3.2-7.1-7.1-7.1s-7.1,3.2-7.1,7.1C20.3,22.2,23.5,25.4,27.4,25.4z  M27.4,15.8c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5C24.9,16.9,26.1,15.8,27.4,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,36.7H29.4V26.6h-4.6v1.3c-0.4,0.1-0.7,0.2-1,0.2l0,0l-0.3,0.1c-1.2,0.4-1.8,0.8-1.8,0.8l0,0 c-2.6,1.4-4.6,3.7-5.6,6.6c-1.1,3.1-1,6.5,0.4,9.6c1.4,3,3.9,5.3,7,6.4c1.4,0.5,2.8,0.8,4.3,0.8c1.8,0,3.6-0.4,5.3-1.2 c3.2-1.5,5.6-4.3,6.6-7.6l4.8,9.2l4.1-2L41.3,36.7z M35.4,41.9c-0.9,3.5-4.1,6-7.6,6c-4.3,0-7.8-3.5-7.8-7.8c0-3,1.8-5.8,4.6-7.2 l0.3-0.2v8.5h10.8L35.4,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,47.1c-2-0.2-5.9-1.9-6.6-6.7l2-0.3c0.7,4.5,4.7,5,4.9,5L27.5,47.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType22);
export default __webpack_public_path__ + "static/media/aioa-icon-type-22.9e2d7af382e5c32da50578409e0305e4.svg";
export { ForwardRef as ReactComponent };